$(function () {
  function showCount($button, $inputs) {
    var inputs = $inputs.filter(function () { return this.checked && !this.disabled });
    var count = inputs.length;
    $button.find('.count').text(' (' + count + ')');
  }

  $('[data-submit-all]').each(function () {
    var url = $(this).attr('data-submit-all');
    var inputName = $(this).attr('data-submit-input-name');
    var submiting = false;
    var $button = $(this).find('button.submit-all');
    var $inputs = $(this).find('input[data-submit-input]');


    $button.append('<span class="count"></span>');

    $(this).find('tr').on('click', function () {
      showCount($button, $inputs);
    });

    $button.on('click', function () {
      if (submiting) return;
      submiting = true;

      var inputs = $inputs.filter(function () { return this.checked && !this.disabled });
      var count = inputs.length;

      showCount($button, $inputs);

      submitAll(inputName, inputs, url, (err, input) => {
        if (err) {
          alert('ERROR: ' + (_.get(err, 'response.data.message') || err.message));
        } else {
          --count;
          $(input).attr("disabled", true);
          
          showCount($button, $inputs);
        }
      }).finally(() => {
        console.log('DONE');
        submiting = false;
      });
    });
  });
});


let submitAll = (inputName, inputs, url, step) => {
  var result = Promise.resolve();

  inputs.each((i, input) => {
    result = result.then((response) => {
      return subminOneInput(inputName, input, url)
        .then(() => {
          step && step(null, input);
        });
    }, (error) => {
      step && step(error, input);
    });
  });

  return result;
}

function subminOneInput(name, input, url) {
  var val = $(input).attr('data-submit-input');

  var data = {};
  data[name] = val;

  return axios.post(url, data);
}